import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../widgets/form/InputTextSF'


const TxnsLoanBalanceModalUI = ({
    context, successMsg, errorList,
    // modes
    submitted, updateLoanBalanceMode, onCreateClick,
    // event handlers
    onSubmit, onLoanBalanceCancelClick, setErrorList,
    // loanBalance attributes and methods
    loanBalanceF, onLoanBalanceFChange, loanBalanceFError, setLoanBalanceFError,
    // dsraCurrent attributes and methods
    dsraCurrentF, onDsraCurrentFChange, dsraCurrentFError, setDsraCurrentFError,
    // dsraTotal attributes and methods
    dsraTotalF, onDsraTotalFChange, dsraTotalFError, setDsraTotalFError,
    // details attributes and methods
    details, onDetailsChange, detailsError, setDetailsError
}) =>
    <ModalFormUI
        context={context}
        titleLabel='Loan Balance'
        buttonLabel='Add Loan Balance'
        cancelLabel='Cancel'
        isOpen={updateLoanBalanceMode}
        onRequestClose={onLoanBalanceCancelClick}
        successMsg={successMsg}
        setErrorList={setErrorList}
        errorList={errorList}
        onSubmit={onSubmit}
        busy={submitted}
    >
        <InputTextSF type='text' name='loanBalanceF' required={true}
            label='Loan Balance'
            value={loanBalanceF} onChange={onLoanBalanceFChange}
            error={loanBalanceFError}
            setError={setLoanBalanceFError}
            autoFocus={true}
        />
        <InputTextSF type='text' name='details' required={true} maxLength={128}
            label='Details'
            value={details} onChange={onDetailsChange}
            error={detailsError} setError={setDetailsError}
        />
        <InputTextSF type='text' name='dsraCurrentF' required={true}
            label='DSRA Current'
            value={dsraCurrentF} onChange={onDsraCurrentFChange}
            error={dsraCurrentFError}
            setError={setDsraCurrentFError}
        />
        <InputTextSF type='text' name='dsraTotalF' required={true}
            label='DSRA Total'
            value={dsraTotalF} onChange={onDsraTotalFChange}
            error={dsraTotalFError} setError={setDsraTotalFError}
        />


    </ModalFormUI>

export default TxnsLoanBalanceModalUI